module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjcuODQgOTQuOTMiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDpub25lO3N0cm9rZTojMDg1NWM0O3N0cm9rZS1taXRlcmxpbWl0OjEwO3N0cm9rZS13aWR0aDo5cHg7fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT5jb3JyZW9fMTwvdGl0bGU+PGcgaWQ9IkNhcGFfMiIgZGF0YS1uYW1lPSJDYXBhIDIiPjxnIGlkPSJDYXBhXzEtMiIgZGF0YS1uYW1lPSJDYXBhIDEiPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTYuMjIsOS45NFM2NSw5Mi44MSwxMjMuMzQsOS45NCIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeD0iNC41IiB5PSI0LjUiIHdpZHRoPSIxMTguODQiIGhlaWdodD0iODUuOTMiIHJ4PSIyLjk0Ii8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconsv4/correo_icon.svg
// module id = OL6g
// module chunks = 1